/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import Header from '../header/header';
import HeaderPerform from '../header/headerPerform';
import HeaderPerformLatest from '../header/headerPerformLatest';
import HeaderPerformLatest2025 from '../header/headerPerformLatest2025';
import Footer from '../footer/footer';
import FooterEbook from '../footer/footerebook';
import FooterPerform from '../footer/footerPerform';
import FooterPerform2023 from '../footer/footerPerform2023';
import FooterPerform2025 from '../footer/footerPerform2025';
import FooterAiLabs from '../footer/footerAiLabs';
import OneTrust from '../marketingScripts/oneTrust';
import MarketoSignUp from '../marketo/marketoSignUp';
import FooterBanner from '../footer/footerBanner.js';
import FooterBannerTwo from '../footer/footerBannerTwo.js';
import AlertBanner from '../header/alertBanner';
import PlannuhPopup from './plannuhPopup.js';
// import AbtestDemo from '../abtestdemo.js';
import "../../sass/app.scss";

const Layout = ({ graphData, children, signup, footerBannerCheck, apphub, layoutCheck, templateCheck, pageClassOverride, ailabs }) => (
  <>
    {graphData &&
      <>
        {graphData.slug !== 'planful-live-demo' && graphData.slug !== 'schedule-a-demo' && graphData.slug !== 'microsite-landing-page' && layoutCheck !== 'layoutnew' && templateCheck === 'no' &&
          <AlertBanner />
        }
        {/* {graphData.slug === 'planful-live-demo' &&
          <AbtestDemo />
        }
        {graphData.slug === 'planful-live-demo-v2' &&
          <AbtestDemo />
        }         */}
      </>
    }
    <OneTrust />
    {graphData &&
      <>
        {graphData.slug === 'perform-old' || graphData.slug === 'register' || graphData.slug === 'post-perform' || graphData.slug === 'perform-2022-on-demand' ?
          <HeaderPerform classCheck={graphData.slug} />
          :
          graphData.slug === 'perform-xx' || graphData.slug === 'speakers' || graphData.slug === 'perform-marketing' ?
            <HeaderPerformLatest classCheck={graphData.slug} />
            :
            graphData.template ?
              <>
                {graphData.template.templateName === 'Perform 2025' &&
                  <HeaderPerformLatest2025 />
                }
              </>
              :
              <>
                {graphData.slug !== 'unsubscribe' &&
                  <Header classCheck={graphData.slug} ailabs={ailabs} apphub={apphub} templateCheck={templateCheck} layoutCheck={layoutCheck} pageClassOverride={pageClassOverride} />
                }
              </>
        }
      </>
    }
    {children}
    {signup === 'blog' &&
      <MarketoSignUp />
    }
    {footerBannerCheck &&
      <>
        {footerBannerCheck === 'yes' &&
          <>
            {graphData ?
              <>
                {graphData.slug !== 'planful-live-demo' && graphData.slug !== 'finance-champions-bring-game-changing-collaboration-to-planning' && graphData.slug !== 'perform' && graphData.slug !== 'post-perform' && graphData.slug !== 'perform-2022-on-demand' && graphData.slug !== 'register' && graphData.slug !== 'jobs' && graphData.slug !== 'about-us' && graphData.slug !== 'life-at-planful' && graphData.slug !== 'partners' && graphData.slug !== 'become-a-planful-partner' && graphData.slug !== 'partner-application' &&
                  <FooterBanner />
                }
                {graphData.slug === 'finance-champions-bring-game-changing-collaboration-to-planning' &&
                  <FooterBannerTwo />
                }
              </>
              :
              <FooterBanner />
            }
          </>
        }
      </>
    }
    {graphData &&
      <>
        {graphData.slug === 'perform-old' || graphData.slug === 'register' || graphData.slug === 'post-perform' || graphData.slug === 'perform-2022-on-demand' ?
          <FooterPerform />
          :
          graphData.slug === 'perform-xx' || graphData.slug === 'speakers' || graphData.slug === 'perform-marketing' ?
            <FooterPerform2023 />
            :
            graphData.template ?
              <>
                {graphData.template.templateName === 'Perform 2025' &&
                  <FooterPerform2025 />
                }
              </>
              :
              <>
                {graphData.slug !== 'unsubscribe' &&
                  <>
                    {layoutCheck ?
                      <>
                        {layoutCheck === 'layoutnew' ?
                          <FooterEbook />
                          :
                          <Footer templateCheck={templateCheck} />
                        }
                      </>
                      :
                      <>
                        {ailabs ?
                          <FooterAiLabs />
                          :
                          <Footer templateCheck={templateCheck} />
                        }
                      </>
                    }
                  </>
                }
              </>
        }
      </>
    }

    {graphData &&
      <>
        {graphData.plannuhPopup &&
          <PlannuhPopup graphData={graphData} />
        }
      </>
    }
  </>
);

export default Layout
